import React, { useState } from "react";
import Hidden from "../components/hidden";
import { Routes, Route } from "react-router-dom";
import { withRouter } from "../utils/router";
import clsx from "clsx";
import { connect } from "react-redux";
import { setError } from "../store/features/error/errorSlice";
import Drawer from '@mui/material/Drawer';
import { 
  setActiveCall,
  setSipSessions,
  setCallingNumber,
} from "../store/features/user/userSlice";
import IconButton from '@mui/material/IconButton';
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import Faxes from "../components/faxes";
import { 
  renderDrawerMenu,
  // renderDialer,
} from "../utils/common";
import { useStyles } from "./styles/viewStyles";

const mapDispatchToProps = {
  setError,
  setActiveCall,
  setSipSessions,
  setCallingNumber,
};

const FaxView = (props) => {
  const { classes } = useStyles();
  const { 
    match,
    window,
    callingNumber,
    setCallingNumber,
  } = props;
  const tab = match.params.type;
  const isCurrentTab = (item) => tab.toLowerCase() === item.type.toLowerCase();
  const [mobileOpen, setMobileOpen] = useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };
  
  const drawerMenuItems = [
    {
      text: "Fax",
      type: "Fax",
      to: "fax/all"
    },
    {
      text: "Fax Groups",
      type: "faxGroup",
      to: "faxgroup/all"
    },
  ];

  const drawerMenu = renderDrawerMenu(
    classes,
    drawerMenuItems,
    isCurrentTab,
    handleDrawerToggle,
    '/dashboard/fax/'
  );

  const container = window !== undefined ? () => window.document.body : undefined;

  const faxMenu = [
    {
      title: "All",
      linkId: "all",
    },
    {
      title: "New",
      linkId: "new",
    },
    {
      title: "Viewed",
      linkId: "viewed",
    },
    {
      title: "Urgent",
      linkId: "urgent",
    },
    {
      title: "Deleted",
      linkId: "deleted",
    },
  ];

  return (
    <div className={classes.root}>
      <nav className={classes.drawer} aria-label="call bar">
        <Hidden mdUp>
          <Drawer
            container={container}
            variant="temporary"
            anchor="left"
            open={mobileOpen}
            onClose={handleDrawerToggle}
            classes={{
              paper: classes.drawerPaper,
            }}
            ModalProps={{
              keepMounted: true,
            }}
          >
            <div
              className={
                mobileOpen
                  ? clsx(classes.menuOpen, classes.menuButton)
                  : clsx(classes.menuClosed, classes.menuButton)
              }
            >
              <IconButton
                aria-label="open menu"
                onClick={handleDrawerToggle}
                className={classes.menuButtonIcon}
                size="large">
                {mobileOpen ? <ChevronLeftIcon /> : <ChevronRightIcon />}
              </IconButton>
            </div>
            {drawerMenu()}
          </Drawer>
        </Hidden>
        <Hidden mdDown>
          <Drawer
            classes={{
              paper: classes.drawerPaper,
            }}
            variant="permanent"
            open
          >
            {drawerMenu()}
          </Drawer>
        </Hidden>
      </nav>
      <Routes>
        {tab.toLowerCase() === "fax" && (
          <Route
            path=":faxTab"
            element={
              <Faxes
                title="Fax"
                menu={true}
                tab={tab}
                menuItems={faxMenu}
                value={callingNumber}
                setValue={setCallingNumber}
                groups={false}
              />
            }
          />
        )}
        {tab.toLowerCase() === "faxgroup" && (
          <Route
            path=":faxTab"
            element={
              <Faxes
                title="Fax Groups"
                menu={true}
                tab={tab}
                menuItems={faxMenu}
                value={callingNumber}
                setValue={setCallingNumber}
                groups={true}
              />
            }
          />
        )}
      </Routes>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    session: state.session,
    phonebook: state.phonebook,
    voip: state.user.voip,
    remoteNumber: state.user.remoteNumber,
    callingNumber: state.user.callingNumber,
  };
};
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(FaxView)
);

